<template>
    <div class="about-upload-avatar">
        <Upload v-model:file-list="fileList" name="file" list-type="picture-card" class="avatar-uploader"
            :show-upload-list="false" :action="uploadUrl" :headers="headers" :capture="null"
            :before-upload="beforeUpload" @change="handleChange">
            <div class="img-size">
                <div v-if="baseInfo?.avatar">
                    <Avatar :src="baseInfo?.avatar" :name="baseInfo?.name" class="avatar" />
                    <div class="hover-div">
                        <span>修改头像</span>
                    </div>
                </div>
                <div v-else>
                    <Avatar :src="baseInfo?.avatar" :name="baseInfo?.name" class="avatar" />
                </div>
            </div>
        </Upload>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { message, Upload } from 'ant-design-vue'
import 'ant-design-vue/es/upload/style/css'

import config from '@/config'
import { getToken } from '@/utils/token'
import { accountApi } from '@/api/account'
import { useUserInfoStore } from '@/stores/user-info'

import Avatar from '@/components/avatar/index.vue'
interface FileItem {
    uid: string
    name?: string
    status?: string
    response?: string
    url?: string
    type?: string
    size: number
    originFileObj: any
}
interface FileInfo {
    file: FileItem
    fileList: FileItem[]
}

const fileList = ref([])
const userStore = useUserInfoStore()
const baseInfo = computed(() => userStore.userInfo)
const loading = ref<boolean>(false)
const imageUrl = ref<string>('')
const handleChange = async (info: FileInfo) => {
    if (info.file.status === 'uploading') {
        loading.value = true
        return
    }
    if (info.file.status === 'done') {
        const response = info?.file?.response as any
        if (response.code == 0) {
            const url = response?.data?.url
            imageUrl.value = url
            loading.value = false
            const res = await accountApi.updateCustomerUser({ id: baseInfo.value.id, avatar: url })
            console.log('handleChange', res)
            userStore.initUserInfo()
        } else {
            message.error(response.message)
        }
    }
    if (info.file.status === 'error') {
        loading.value = false
        message.error('头像上传失败')
    }
}

const beforeUpload = (file: FileItem) => {
    const isJpgOrPng =
        file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
    if (!isJpgOrPng) {
        message.error('只支持jpeg、png、jpg格式的图片')
    }
    const isLt10M = file.size / 1024 / 1024 < 10
    if (!isLt10M) {
        message.error('上传图片不能大于10M')
    }
    return isJpgOrPng && isLt10M
}

const headers = {
    token: getToken()
}
const uploadUrl = config.uploadAvatarUrl() + '/llm/wx/uploadAvatar'
</script>
<style scoped lang="less">
.about-upload-avatar {
    :deep(.ant-upload.ant-upload-select-picture-card) {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: none;
    }

    width: 40px;
    height: 40px;

    .img-size {
        position: relative;

        .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #e8e8e8;
            object-fit: cover;
        }

        &:hover {
            .hover-div {
                display: block;
            }
        }
    }

    .hover-div {
        background: rgba(0, 0, 0, 0.6);
        width: 39px;
        height: 39px;
        border-radius: 50%;
        text-align: center;
        font-size: 12px;
        position: absolute;
        top: 0px;
        right: 0px;
        display: none;

        span {
            display: inline-block;
            transform: scale(0.6);
            color: #fff;
            margin-left: -4px;
        }

        white-space: nowrap;
        line-height: 39px;
    }
}
</style>
